const getAutoClose = (autoClose, notificationAutoClose) => {
  if (typeof notificationAutoClose === 'number') {
    return notificationAutoClose;
  }
  if (notificationAutoClose === false || autoClose === false) {
    return false;
  }
  return autoClose;
};

export { getAutoClose };
